// extracted by mini-css-extract-plugin
module.exports = {"container":"_2cgkZ","prefixLabel":"_2q8G2"};